<script setup lang="ts">
import { computed } from 'vue';

import BiomarkerExplainerContent from './BiomarkerExplainerContent.vue';

const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    biomarkerId?: string;
  }>(),
  {
    biomarkerId: 'MYOSI',
  },
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'update:biomarkerId', id: string): void;
}>();

const isOpen = computed({
  get: () => props.modelValue,
  set: val => emit('update:modelValue', val),
});

const onBiomarkerChange = (newId: string) => {
  emit('update:biomarkerId', newId);
};
</script>

<template>
  <v-dialog
    v-model="isOpen"
    max-width="960px"
    max-height="90vh"
    scrollable
    class="biomarker-explainer-dialog"
  >
    <v-card class="explainer-modal-card">
      <div class="explainer-dialog-topbar">
        <div class="dialog-title">
          Biomarker Explanation
        </div>
        <button
          class="dialog-close-btn"
          aria-label="Close"
          @click="isOpen = false"
        >
          <i class="fa-solid fa-xmark" />
        </button>
      </div>

      <v-card-text class="explainer-scroll-area">
        <BiomarkerExplainerContent
          :biomarker-id="biomarkerId"
          @update:biomarker-id="onBiomarkerChange"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.explainer-modal-card {
  background: var(--md-surface, #1e1e24) !important;
  color: var(--md-text-primary, #ffffff) !important;
  border: 1px solid var(--md-outline, rgba(255, 255, 255, 0.15)) !important;
  border-radius: 16px !important;
  box-shadow: 0 16px 40px var(--glass-shadow, rgba(0, 0, 0, 0.45)) !important;
  display: flex;
  flex-direction: column;
  max-height: 88vh;
  overflow: hidden;
}

.explainer-dialog-topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 20px;
  border-bottom: 1px solid var(--md-outline, rgba(255, 255, 255, 0.1));
  background: var(--glass-bg-secondary, rgba(255, 255, 255, 0.03));
  flex-shrink: 0;
}

.dialog-title {
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: var(--md-text-primary, #ffffff);
}

.dialog-close-btn {
  background: transparent;
  border: 0;
  color: var(--md-text-secondary, #90a4ae);
  font-size: 16px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.dialog-close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.explainer-scroll-area {
  padding: 18px 22px !important;
  overflow-y: auto !important;
  min-height: 0;
}

.explainer-scroll-area::-webkit-scrollbar {
  width: 6px;
}

.explainer-scroll-area::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}
</style>
